import { QWIKFIX_LOGO_DARK_SRC, QWIKFIX_LOGO_LIGHT_SRC } from './qwikfixBrand';

export default function QwikFixLogo({
  className = 'h-8 w-auto max-w-[200px]',
  variant = 'dark',
}: {
  className?: string;
  variant?: 'light' | 'dark';
}) {
  const src = variant === 'light' ? QWIKFIX_LOGO_DARK_SRC : QWIKFIX_LOGO_LIGHT_SRC;
  return (
    <img src={src} alt='TheQwikFix' className={className} width={200} height={37} />
  );
}
